<div class="container-departamentos">

    <div class="container-title">
        <h1 class="title quicksand-medium"> DEPARTAMENTO DE INGRESOS </h1>
    </div>

    <div class="departamentos">

        <div class="info" *ngFor="let dept of data.departments">
            <h3 class="title quicksand-medium">{{dept.campusName}}</h3>
            <div class="content">
                <div class="conoce">
                    <span class="quicksand-medium">CONOCÉ NUESTRAS CARRERAS >></span>
                </div>
                <div class="buttons">

                    <a class="icon" *ngIf="dept.facebook" [href]="dept.facebook" target="_blank">
                        <img src="./assets/inscripcion/facebook.png" alt="">
                    </a>

                    <a class="icon" *ngIf="dept.instagram" [href]="dept.instagram" target="_blank">
                        <img src="./assets/inscripcion/instagram.png" alt="">
                    </a>

                    <a class="icon" *ngIf="dept.email" [href]="'mailto:' + dept.email">
                        <img src="./assets/inscripcion/mail.png" alt="">
                    </a>

                    <a class="icon" *ngIf="dept.phone" [href]="'tel:' + dept.phone">
                        <img src="./assets/inscripcion/phone.png" alt="">
                    </a>

                    <a class="button quicksand-medium desk" [href]="dept.whatsapp" Target="_blank">
                        CONTACTANOS
                        <img src="./assets/img/whatsapp-blanco2.png" alt="">
                    </a>
                </div>
                <div class="mob buttons">
                    <a class="button mob quicksand-medium" [href]="dept.whatsapp" Target="_blank">
                        CONTACTANOS
                        <img src="./assets/img/whatsapp-blanco2.png" alt="">
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>